import { IntercomProviderProps } from "react-use-intercom";

export const intercomConfig: IntercomProviderProps = {
    appId: process.env.REACT_APP_INTERCOM_APPID || '',
};
